export const CLODUINARY_IMAGE_SIZE = {
  MOBILE: {
    WIDTH: 400,
    HEIGHT: 250,
  },
  DESKTOP: {
    WIDTH: 600,
    HEIGHT: 400,
  },
};

const CLOUDINARY_DEFAULT_TRANSFORMATIONS = [
  "fl_lossy",
  "f_auto",
  "q_auto",
  "w_auto",
];

export const getCloudinaryUrl = (imgSrc) => {
  let splitImg = imgSrc.split("/upload/");
  const transformations = [...CLOUDINARY_DEFAULT_TRANSFORMATIONS];
  return `${splitImg[0]}/upload/${transformations}/${splitImg[1]}`;
};
